export default function updateFavicon(settings: {
  brand: { favicon: string | null };
}) {
  if (settings.brand.favicon) {
    const el = document.querySelector('#favicon');
    if (el) {
      el.setAttribute('href', settings.brand.favicon);
    }
  }
}
